const chooseProducts = () => {
  let productCount = 0;
  const toggleItems = (targetLocale) => {
    const productItems = document.querySelectorAll('product-item');
    let userLocale = '{{ localization.language.iso_code }}';
    if (targetLocale) {
      userLocale = targetLocale;
    } else if (document.querySelector('.wgcurrent') && document.querySelector('.wgcurrent').dataset.l) {
      userLocale = document.querySelector('.wgcurrent').dataset.l;
    }
    productItems.forEach((item) => {
      if (!item.dataset.l || item.dataset.l == "" || item.dataset.l == userLocale || item.dataset.l == 'en') {
        item.style.display = 'block';
        productCount++;
      } else {
        item.style.display = 'none';
      }
    });
  }
  const targetAndToggle = () => {
    toggleItems(null);
    let targetLocale = null;
    document.querySelector('.weglot-container').querySelector('ul').querySelectorAll('a').forEach((item) => {
      item.addEventListener('mouseover', () => {
        if (item.parentElement && item.parentElement.dataset.l) {
          targetLocale = item.parentElement.dataset.l;
        }
      });
      item.addEventListener('touchend', () => {
        if (item.parentElement && item.parentElement.dataset.l) {
          targetLocale = item.parentElement.dataset.l;
        }
      });
      item.addEventListener('click', (event) => {
        event.preventDefault();
        if (item.parentElement && item.parentElement.dataset.l) {
          toggleItems(targetLocale);
        }
      });
    });
  }
  targetAndToggle();
  const facet = document.querySelector('.product-facet__meta-bar-item--count');
  if (facet) {
    facet.innerText = facet.innerText.replace(/\d+/, productCount.toString());
  }
  console.log(productCount)
  const callback = (mutationList, observer) => {
    mutationList.forEach((mutation) => {
      if (mutation.target != facet && mutation.target.id != 'ProductCountDesktop') {
        productCount = 0;
        targetAndToggle();
        if (facet) {
          facet.innerText = facet.innerText.replace(/\d+/, productCount.toString());
        }
      }
    });
  };
  const observer = new MutationObserver(callback);
  observer.observe(document, { attributes: true, childList: true, subtree: true });
}
window.addEventListener('load', chooseProducts);
